import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useInProgress } from 'logic/store/tracker/tracker.hooks';
import { offerSlice } from 'logic/store/offer/offer.slice';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { PrimaryButton } from 'components/buttons/primary-button/primary.button';
import { useLocalizedI18nGlobal } from 'logic/translations/use-localized-i18n-global';

type Props = {
  disabled: boolean;
};

export const RequestTutoringButton: React.FC<Props> = ({ disabled }) => {
  useLocalizedI18nGlobal();
  const dispatch = useDispatch();
  const isRequestOfferInProgress = useInProgress(offerSlice.actions.requestOffer);

  const handleRequestLesson = useCallback(() => dispatch(offerSlice.actions.requestOffer()), [
    dispatch,
  ]);

  return (
    <PrimaryButton
      onClick={handleRequestLesson}
      disabled={isRequestOfferInProgress || disabled}
      loading={isRequestOfferInProgress}
    >
      {translate(translationKeys.buttons.requestLessons)}
    </PrimaryButton>
  );
};
